import ROWS_PER_PAGE from '../../models/rowsPerPage.js';
import _ from 'lodash';

const REFRESH_ON_SHOW_EVENT = 'refreshOnShow';

class TableComponentController {
  constructor(tableService, $filter, $scope) {

    this.name = 'tableComponent';
    this.tableService = tableService;
    this.$filter = $filter;
    this.$scope = $scope;
    this.uriParams = {
      rowsPerPage: ROWS_PER_PAGE,
      pageNumber: 1
    };

    if (this.hasToFetchTableDataForCurrentUri()) {
      this.data = {};
      this.getTableData();
    }

    this.watchForOnShow();
  }

  hasToFetchTableDataForCurrentUri() {
    let urisNotUsingTableService = ['/schools', '/courses', '/products', '/classes', '/userAccount', '/sourceErrors', '/dataBrowser', '/orchestrationErrors', '/resources', '/connectedErrors', '/aleks-master-templates'];

    let isNotToFetchDataForCurrentUri = _.find(urisNotUsingTableService, (uri) => {
      return uri === this.options.uri;
    });

    if(!isNotToFetchDataForCurrentUri){
      return true;
    }
  }

  getTableData() {
    let queryString = this.getQueryString();
    let url = this.options.uri + queryString;

    this.tableService.getTableData(url)
      .then(this.setTableData.bind(this));
  }

  getQueryString() {
    var queryURI = '?';

    for (var key in this.uriParams) {
      queryURI += `${key}=${this.uriParams[key]}&`;
    }

    return queryURI.slice(0, queryURI.length - 1);
  }

  setTableData(results) {
    this.data = results.data;
    this.data.content = this.data.content.filter(item => item.level !== 4)
  }

  search(searchColumn, searchValue) {
    this.setSearchExpression(searchColumn, searchValue);
    this.getTableData().then(this.applySearchFilters.bind(this));
  }

  setSearchExpression(searchColumn, searchValue) {
    this.searchExpression = {};
    this.searchExpression[searchColumn] = searchValue;
  }

  applySearchFilters() {
    this.data.content = this.$filter('filter')(this.data.content, this.searchExpression);
  }

  getRowCount() {
    return this.data.content.length;
  }

  watchForOnShow() {
    this.$scope.$on(REFRESH_ON_SHOW_EVENT, this.onRefreshOnShow.bind(this));
  }

  onRefreshOnShow() {
    if (this.refreshOnShow) {
      this.data = {};
      this.getTableData();
    }
  }
}

TableComponentController.$inject = ['tableService', '$filter', '$scope'];

export
default TableComponentController;



// WEBPACK FOOTER //
// ./app/components/tableComponent/tableComponent.controller.js